import React, {useEffect, useState} from "react";
import api from "../../api/client";
import {useNavigate} from "react-router-dom";
import LoadingInside from "../../components/Loading/LoadingInside";
import TourHorizontalScroller from "../../components/TourHorizontalScroller/TourHorizontalScroller";
import SeoMeta from "../../components/SeoMeta";
import s from "./SpecialOffers.module.scss";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import ComboHorizontalScroller from "../../components/ComboHorizontalScroller/ComboHorizontalScroller";
import NotFound from "../../components/Loading/NotFound";

const apiUrl = process.env.REACT_APP_API_URL;
const SpecialOffers = ({slug}) => {
    const [page, setPage] = useState(null);
    const [loadingPage, setLoadingPage] = useState(true);
    const navigate = useNavigate();
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [tours, setTours] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(true);
    const [loadingTours, setLoadingTours] = useState(false);
    const [combos, setCombos] = useState([]);
    const [loadingCombos, setLoadingCombos] = useState(false);
    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: page?.primary_title}
    ];
    const [tourPage, setTourPage] = useState(1);
    const [hasMoreTours, setHasMoreTours] = useState(true);
    const [loadingMoreTours, setLoadingMoreTours] = useState(false);
    const [comboPage, setComboPage] = useState(1);
    const [hasMoreCombos, setHasMoreCombos] = useState(true);
    const [loadingMoreCombos, setLoadingMoreCombos] = useState(false);
    const [pageError, setPageError] = useState(false);

    useEffect(() => {
        if (!slug) return;

        loadPage();
    }, [slug]);

    const loadPage = async () => {

        setLoadingPage(true);
        setPageError(false);

        try {

            const res = await api.get(
                `${apiUrl}/api/special-tour/slug/${slug}`
            );

            setPage(res.data.data);

        } catch (err) {

            console.error(err);
            setPageError(true);

        } finally {

            setLoadingPage(false);

        }

    };

    /*
            Load tours
                */


    const loadTours = async (
        pageId,
        pageNumber = 1,
        reset = false
    ) => {

        if (loadingMoreTours) return;

        setLoadingMoreTours(true);

        try {

            const res = await api.get(
                `${apiUrl}/api/special-tour/tours/${pageId}`,
                {
                    params: {
                        page: pageNumber
                    }
                }
            );

            const data = res.data.data || [];

            if (reset) {

                setTours(data);

            } else {

                setTours(prev => [
                    ...prev,
                    ...data
                ]);

            }

            setHasMoreTours(data.length > 0);
            setTourPage(pageNumber);

        } finally {

            setLoadingMoreTours(false);

        }
    };
    const loadCombos = async (
        pageId,
        pageNumber = 1,
        reset = false
    ) => {

        if (loadingMoreCombos) return;

        if (reset) {
            setLoadingCombos(true);
        } else {
            setLoadingMoreCombos(true);
        }

        try {

            const res = await api.get(
                `${apiUrl}/api/special-tour/combos/${pageId}`,
                {
                    params: {
                        page: pageNumber
                    }
                }
            );

            const data = res.data.data || [];

            if (reset) {

                setCombos(data);

            } else {

                setCombos(prev => [
                    ...prev,
                    ...data
                ]);

            }

            setHasMoreCombos(data.length > 0);
            setComboPage(pageNumber);

        } finally {

            setLoadingCombos(false);
            setLoadingMoreCombos(false);

        }
    };
    useEffect(() => {
        if (!page?.id) return;

        loadTours(page.id, 1, true);
        loadCombos(page.id, 1, true);

    }, [page?.id]);

    if (loadingPage) {
        return <LoadingInside height="50vh" />;
    }
    if (pageError || !page) {
        return (
            <NotFound></NotFound>
        );
    }
    return (
        <>
            <SeoMeta
                slug={
                    window.location.pathname
                }
                fallback={{
                    title:
                    page.primary_title,
                    description:
                    page.primary_title
                }}
            />
            <div className={s.page}>
                {/* TITLE */}
                <div className="row mt-3 mb-3">
                    <div className="col-12">
                        <Breadcrumb items={breadcrumbItems}/>
                        <div className={s.titleWrrapper}>
                            <img className={s.titleImage} src={titleImage}/>
                            <h2 className={s.primaryTitle}>{page?.primary_title}</h2>
                            <h3 className={s.secondaryTitle}>{page?.secondary_title}</h3>
                        </div>
                    </div>
                </div>
                {page.show_tour_section===1  && (
                <div className={s.tourArea}>
                    <h3>
                        {page.tour_section_primary_title}
                        <span>{page.tour_section_secondary_title}</span>
                    </h3>
                    {
                        loadingTours
                            ?
                            <LoadingInside
                                height="40vh"
                            />
                            :

                            <TourHorizontalScroller
                                tours={tours}
                                loadMore={() => loadTours(page.id, tourPage + 1)
                                }
                                hasMore={hasMoreTours}
                                loading={loadingMoreTours}
                            />
                    }
                </div>
                ) }

                {page.show_combo_section===1 && combos?.length > 0 && (
                    <div className={s.tourArea}>
                        <h3>
                            {page.combo_section_primary_title}
                            <span>{page.combo_section_secondary_title}</span>
                        </h3>

                        {loadingCombos ? (
                            <LoadingInside height="40vh"/>
                        ) : (
                            <ComboHorizontalScroller
                                combos={combos}
                                loadMore={() =>
                                    loadCombos(page.id, comboPage + 1)
                                }
                                hasMore={hasMoreCombos}
                                loading={loadingMoreCombos}
                            />
                        )}
                    </div>
                )}
            </div>
        </>
    );
};
export default SpecialOffers;